module.exports = __webpack_public_path__ + "img/icon_lamisil.9191bc7c.png";